import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";

import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import moment from "moment";
import { Tooltip } from "@mui/material";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { formattedPrice } from "../../utils";
// import { useGetCollectPaymentContext } from "../../context";
// import { validatePaymentMode } from "../components/constant";


const ListComponent = forwardRef(
  (
    {
      loader,
      rows,
    },
    ref
  ) => {
    
    const eventsMapping={
      settled:'Settled',
      bounced:'Bounced',
      debited:'Debited'
    }
    const columns = [
        new AGridColDef("dueDate", "Due Date", false)
        .setMinWidth(80)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <Tooltip title={moment(params?.value).format('DD-MMM-YYYY')}>
            <div className={`ellipsis-text-container`}>{moment(params?.value).format('DD-MMM-YYYY')}</div>
          </Tooltip> : <div>-</div>
        )),
        new AGridColDef("jodoEvent", "JODO Event", false)
        .setMinWidth(80)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <Tooltip title={eventsMapping?.[(params?.value).toLowerCase()]}>
            <div className={`ellipsis-text-container`} style={(params?.value).toLowerCase()=='bounced'?{color:'#DC2804'}:{}}>{eventsMapping?.[(params?.value).toLowerCase()]}</div>
          </Tooltip> : <div>-</div>
        )),
        new AGridColDef("transactionRefNumber", "Transaction Ref. Number", false)
        .setMinWidth(100)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip>: <div>-</div>
        )),
        new AGridColDef("amount", "Amount", false)
        .setMinWidth(60)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <Tooltip title={formattedPrice(params?.value)}>
            <div className={`ellipsis-text-container`}>{formattedPrice(params?.value)}</div>
          </Tooltip> : <div>-</div>
        )),
        new AGridColDef("transactionDate", "Transaction Date", false)
        .setMinWidth(80)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <Tooltip title={moment.utc(params?.value).format('DD-MMM-YYYY HH:mm:ss')}>
            <div className={`ellipsis-text-container`}>{moment.utc(params?.value).format('DD-MMM-YYYY HH:mm:ss')}</div>
          </Tooltip> : <div>-</div>
        ))
    ];

    return (<>
      <div className="" style={{border:'1px solid #EEE', borderRadius:'8px'}}>
        <ADataGrid
          removeWrapperContainer
          rowModesModel
          rows={rows || []}
          columns={columns}
          rowId={(row) => row?.id}
          rowHeight={50}
          rowCount={rows.length}
          loading={false}
          components={{
            ...gridComponents,
            NoRowsOverlay: () => (
              <NoRowOverlay message={loader ? "Loading..." : null} />
            ),
          }}
          sx={{
            ...gridStyles,
          }}
          autoHeight
          hidePagination={true}
        />
      </div>
      </>
    );
  }
);
export default ListComponent;
